import { CommonModule } from '@angular/common';
import { Component, computed, inject, input, output } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { SelectDialogComponent } from '@scandium-oy/ngx-scandium';
import { AppCommonModule } from 'src/app/common.module';
import { Site } from 'src/app/models/site.model';

@Component({
  selector: 'app-select-site-button',
  // eslint-disable-next-line @angular-eslint/component-max-inline-declarations
  template: `
    <ion-button [expand]="expand()" shape="round" [color]="color()" (click)="selectSite()" [disabled]="disabled()">
      @if (icon()) {
        <ion-icon slot="start" [name]="icon()"></ion-icon>
      }
      @if (text()) {
        {{ text() | translate }}
      } @else {
      @if (selectedSite()) {
        @if (isArray()) {
          @if ($any(selectedSite()).length > 0) {
            @for (site of $any(selectedSite()); track site.guid; let last = $last) {
              <div>{{ site.name }}@if (!last) {,&nbsp;}</div>
            }
          } @else {
            {{ title() | translate }}
          }
        } @else {
      <span>
        {{ $any(selectedSite()).name }}
      </span>
        }
      } @else {
        {{ title() | translate }}
      }
    }
    </ion-button>
  `,
  imports: [
    AppCommonModule,
    CommonModule,

  ],
})
export class SelectSiteButtonComponent {
  private modalCtrl = inject(ModalController);

  selectedSite = input<Site | Site[]>();
  items = input<Site[]>();
  multiple = input(false);
  color = input('light');
  expand = input('');
  icon = input('');
  title = input('report.selectSite');
  text = input<string>();
  hasNew = input(false);
  disabled = input(false);
  sortFavorites = input(false);

  isArray = computed(() => Array.isArray(this.selectedSite()));

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selected = output<any>();

  selectSite() {
    const clearButton = this.selectedSite() != null;
    this.modalCtrl.create({
      component: SelectDialogComponent<Site>,
      componentProps: { items: this.items(), clearButton, multiple: this.multiple() },
    })
      .then((m) => {
        m.present();

        m.onDidDismiss().then((data) => {
          if (data.data) {
            if (data.data.clear) {
              this.selected.emit(null);
            } else {
              this.selected.emit(data.data);
            }
          }
        });
      });
  }
}
